/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_File_EncodingInputs */



/**
* | output |
* | --- |
* | "File Encoding" |
*
* @param {Subtitle_Export_File_EncodingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_file_encoding = /** @type {((inputs?: Subtitle_Export_File_EncodingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_File_EncodingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Encodage de fichier")
	if (locale === "de") return /** @type {LocalizedString} */ ("Dateikodierung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Codifica dei file")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Кодировка файла")
	if (locale === "es") return /** @type {LocalizedString} */ ("Codificación de archivos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("文件编码")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ファイルのエンコーディング")
	if (locale === "hi") return /** @type {LocalizedString} */ ("फ़ाइल एन्कोडिंग")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Codificação de arquivo")
	return /** @type {LocalizedString} */ ("File Encoding")
});